import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "../../../components/Icon/Icon";
import PageHeader from "../../../components/PageHeader/PageHeader";
import TableFilter from "../../../components/TableFilter/TableFilter";
import PaginationComponent from "../../../components/Pagination/Pagination";
import EmptyData from "../../../helpers/EmptyData/EmptyData";
import InfoItem from "./../../../helpers/InfoItem/InfoItem";
import Currency, { ConvertCurrency } from "../../../helpers/Currency/Currency";
import { Block } from "../../../components/Block/Block";
import { Row, Col } from "../../../components/Grid/Grid";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "../../../components/DataTable/DataTable";
import { snappTripBooksAdminContext } from "../../../context/AdminContext/SnappTripBooksAdminContext/SnappTripBooksAdminContext";
import { convertDate, numberSeparate } from "../../../utils";
import {
  convertSnappTripBookStateToColor,
  convertSnappTripBookStateToText,
} from "../../../utils/enum";

const SnappTripBooksAdmin = () => {
  const {
    books,
    book,
    setBook,
    pageCount,
    pageNumber,
    setPageNumber,
    itemsCount,
    setItemsCount,
    handleGetBooks,
    handleGetBook,
    handleGetBookVoucher,
  } = useContext(snappTripBooksAdminContext);

  useEffect(() => {
    handleGetBooks();
  }, [pageNumber, itemsCount]);

  return (
    <>
      <SiteTitle title="رزروهای اسنپ تریپ" />

      <PageHeader title="رزروهای اسنپ تریپ" />

      <TableFilter setItemsCount={setItemsCount} itemsCount={itemsCount} />

      <Block>
        <DataTable className="card-stretch">
          <DataTableBody>
            <DataTableHead>
              <DataTableRow>
                <span className="sub-text">#</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">شماره رزرو</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">تاریخ ورود و خروج</span>
              </DataTableRow>
              <DataTableRow size="lg">
                <span className="sub-text">
                  قیمت نهایی <Currency />
                </span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">وضعیت</span>
              </DataTableRow>
              <DataTableRow />
            </DataTableHead>
            {/*Head*/}
            {!isEmpty(books) &&
              books.map((item, index) => (
                <DataTableItem key={item._id}>
                  <DataTableRow>
                    <span>{index + 1}</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span>{item.reservation_code}</span>
                  </DataTableRow>
                  <DataTableRow size="sm">
                    <span>
                      {convertDate(item.checkin)} - {convertDate(item.checkout)}
                    </span>
                  </DataTableRow>
                  <DataTableRow size="lg">
                    <span>
                      <ConvertCurrency price={item?.final_price} />
                    </span>
                  </DataTableRow>
                  <DataTableRow>
                    <Badge
                      className="badge-dim"
                      color={convertSnappTripBookStateToColor(item?.state)}
                    >
                      {convertSnappTripBookStateToText(item?.state)}
                    </Badge>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            tag="a"
                            className="dropdown-toggle btn btn-icon btn-trigger"
                          >
                            <Icon name="more-h" />
                          </DropdownToggle>
                          <DropdownMenu left className="dropdown_max_height">
                            <ul className="link-list-opt no-bdr text-right">
                              <li
                                onClick={() =>
                                  handleGetBookVoucher(
                                    item.reservation_code,
                                    "fa"
                                  )
                                }
                              >
                                <DropdownItem tag="a" type="button">
                                  <Icon name="reports-alt" />
                                  <span>دریافت رسید فارسی</span>
                                </DropdownItem>
                              </li>
                              <li
                                onClick={() =>
                                  handleGetBookVoucher(
                                    item.reservation_code,
                                    "en"
                                  )
                                }
                              >
                                <DropdownItem tag="a" type="button">
                                  <Icon name="reports-alt" />
                                  <span>دریافت رسید انگلیسی</span>
                                </DropdownItem>
                              </li>
                              <li
                                onClick={() =>
                                  handleGetBook(item.reservation_code)
                                }
                              >
                                <DropdownItem tag="a" type="button">
                                  <Icon name="eye" />
                                  <span>جزئیات</span>
                                </DropdownItem>
                              </li>
                            </ul>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </DataTableRow>
                </DataTableItem>
              ))}
          </DataTableBody>
          <div className="card-inner">
            {isEmpty(books) ? (
              <EmptyData />
            ) : (
              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            )}
          </div>
        </DataTable>
      </Block>

      <Modal
        isOpen={!isEmpty(book)}
        toggle={() => setBook({})}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <span type="button" onClick={() => setBook({})} className="close">
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">جزئیات رزور {book?.hotel_name}</h5>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات رزور
            </span>
            <Row>
              <Col sm="6">
                <InfoItem title="هتل">
                  <span>{book?.hotel_name}</span>
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="شماره رزرو">{book.reservation_code}</InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="وضعیت">
                  <Badge
                    className="badge-dim"
                    color={convertSnappTripBookStateToColor(book?.state)}
                  >
                    {convertSnappTripBookStateToText(book?.state)}
                  </Badge>
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ ورود">
                  {convertDate(book.checkin)}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تاریخ خروج">
                  {convertDate(book.checkout)}
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="تخت اضافه">
                  {numberSeparate(book.extra_beds)}
                </InfoItem>
              </Col>
              <Col sm="12">
                <InfoItem title="درخواست های ویژه">
                  {book.special_requests}
                </InfoItem>
              </Col>
            </Row>
            <br />
            <span className="text-primary border-bottom fw-bold">
              اطلاعات مالی
            </span>
            <Row>
              {book?.discount_code && (
                <Col sm="6">
                  <InfoItem title="کد تخفیف">
                    <span>{book?.discount_code}</span>
                  </InfoItem>
                </Col>
              )}
              <Col sm="6">
                <InfoItem title="تخفیف">
                  <span>{book?.discount}%</span>
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="قیمت تخت اضافه">
                  <ConvertCurrency price={book?.extra_bed_fee} /> <Currency />
                </InfoItem>
              </Col>
              <Col sm="6">
                <InfoItem title="قیمت نهایی">
                  <ConvertCurrency price={book?.final_price} /> <Currency />
                </InfoItem>
              </Col>
            </Row>
            {!isEmpty(book?.rooms) && (
              <>
                <br />
                <span className="text-primary border-bottom fw-bold">
                  اطلاعات اتاق ها
                </span>
                {book?.rooms?.map((item) => (
                  <Row
                    key={item?._id}
                    className="border rounded mb-2 border-primary m-0"
                  >
                    <Col sm="6">
                      <InfoItem title="نوع اتاق">{item?.title}</InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="قیمت نهایی">
                        <ConvertCurrency price={item?.final_price} />
                        <Currency />
                      </InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="تخت اضافه">
                        {numberSeparate(item?.extra_beds)}
                      </InfoItem>
                    </Col>
                    <Col sm="6">
                      <InfoItem title="قیمت تخت اضافه">
                        <ConvertCurrency price={item?.extra_bed_fee} />{" "}
                        <Currency />
                      </InfoItem>
                    </Col>
                    <Col size="12">
                      {!isEmpty(item?.guests) && (
                        <>
                          <br />
                          <span className="text-primary border-bottom fw-bold">
                            اطلاعات میهمانان
                          </span>
                          {item?.guests?.map((_item) => (
                            <Row
                              key={_item?._id}
                              className="border rounded mb-2 border-primary m-0"
                            >
                              <Col sm="6">
                                <InfoItem title="نام">
                                  {_item?.first_name}
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="نام خانوادگی">
                                  {_item?.last_name}
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="خارجی">
                                  <Icon
                                    name={_item?.foreigner ? "check" : "cross"}
                                    className={`text-${
                                      _item?.foreigner ? "success" : "danger"
                                    }`}
                                  />
                                </InfoItem>
                              </Col>
                              <Col sm="6">
                                <InfoItem title="نیم شارژ">
                                  <Icon
                                    name={_item?.is_extra ? "check" : "cross"}
                                    className={`text-${
                                      _item?.is_extra ? "success" : "danger"
                                    }`}
                                  />
                                </InfoItem>
                              </Col>
                            </Row>
                          ))}
                        </>
                      )}
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SnappTripBooksAdmin;
